"use client";

import React from "react";
import RolesTable from "../roles_table/RolesTable";

const Management: React.FC = () => {
  return (
    <section>
      <RolesTable />
    </section>
  );
};

export default Management;
